import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { UserCheck, LogOut, ChevronRight } from "lucide-react";
import { getMyLifecycle } from "../../Moduels/Lifecycle/lifecycleApi";

export default function EmployeeLifecycleCard() {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({
    queryKey: ["my-lifecycle"],
    queryFn: getMyLifecycle,
    staleTime: 60_000,
    retry: 1,
  });

  const onboarding = data?.onboarding;
  const offboarding = data?.offboarding;

  if (isLoading) return null;
  if (!onboarding && !offboarding) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      {onboarding && (
        <button
          type="button"
          onClick={() => navigate("/my-onboarding")}
          className="pw-card text-left hover:shadow-md transition-shadow w-full"
        >
          <div className="pw-card-body flex items-start justify-between gap-3">
            <div>
              <div className="flex items-center gap-2 text-violet-700 font-semibold text-sm">
                <UserCheck className="w-4 h-4" />
                My Onboarding
              </div>
              <p className="text-lg font-bold text-slate-900 mt-1">{onboarding.status}</p>
              <p className="text-sm text-slate-500 mt-1">
                Documents {onboarding.documents?.done ?? 0}/{onboarding.documents?.total ?? 0}
                {" · "}
                Tasks {onboarding.tasks?.done ?? 0}/{onboarding.tasks?.total ?? 0}
              </p>
              {onboarding.date_of_joining && (
                <p className="text-xs text-slate-400 mt-1">Joining: {onboarding.date_of_joining}</p>
              )}
            </div>
            <ChevronRight className="w-5 h-5 text-slate-400 shrink-0 mt-1" />
          </div>
        </button>
      )}
      {offboarding && (
        <button
          type="button"
          onClick={() => navigate("/my-exit")}
          className="pw-card text-left hover:shadow-md transition-shadow w-full"
        >
          <div className="pw-card-body flex items-start justify-between gap-3">
            <div>
              <div className="flex items-center gap-2 text-red-700 font-semibold text-sm">
                <LogOut className="w-4 h-4" />
                My Exit
              </div>
              <p className="text-lg font-bold text-slate-900 mt-1">{offboarding.status}</p>
              <p className="text-sm text-slate-500 mt-1">
                Clearance {offboarding.clearance?.done ?? 0}/{offboarding.clearance?.total ?? 0}
              </p>
              {offboarding.last_working_day && (
                <p className="text-xs text-slate-400 mt-1">Last day: {offboarding.last_working_day}</p>
              )}
            </div>
            <ChevronRight className="w-5 h-5 text-slate-400 shrink-0 mt-1" />
          </div>
        </button>
      )}
    </div>
  );
}
